<template>
  <div class="cell-group">
    <div class="cell-group-title_wrapper">
      <div class="cell-group-title">{{ title }}</div>
      <div class="cell-group-title_line" />
    </div>
    <div class="cell-group-container">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String
  },

  data() {
    return {

    }
  }
}
</script>

<style lang='scss' scoped>
.cell-group {
    + .cell-group {
        margin: 65px 0 0;
    }
    .cell-group-title_wrapper {
        display: flex;
        align-items: flex-end;
        font-size: 16px;
        .cell-group-title {
            position: relative;
            padding: 0 19px 0 9px;
            font-weight: bold;
            border-left: 6px solid #4D4D4D;
        }
        .cell-group-title_line {
            flex: 1;
            border-bottom: 1px dashed #EBEBEB;
        }
    }
    .cell-group-container {
        padding: 40px 20px 0;
    }
}
</style>
